import { Paragraph, TextProps } from '@/components/common/Typography';
import GeneralDisclosuresLink from '@/components/compliance/GeneralDisclosuresLink';

export const DisclosureParagraph = ({ ...props }: TextProps) => (
    <Paragraph
        mb={2}
        fontSize="sm"
        color="gray.400"
        fontWeight="light"
        lineHeight={1.5}
        {...props}
    />
);

export const RiskyDisclosureParagraph = ({ ...props }: TextProps) => (
    <DisclosureParagraph {...props}>
        Investing is inherently risky and Plenty Financial does not guarantee
        positive performance. Investors may experience possible loss of
        principal. For important disclosures regarding Plenty’s interactive
        analysis tool using hypothetical performance data, please see Plenty’s{' '}
        <GeneralDisclosuresLink />.
    </DisclosureParagraph>
);
